import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/router";
import React from "react";
import styles from "./GiftCard.module.scss";
import type { SanityImageObject } from "@sanity/image-url";
import { ResponsiveImage } from "../../../shared/responsiveimage";
import { LinkType, Links, LinksProps } from "../Links/Links";
import { NavLink } from "../../../shared/components/Navbar/Navbar";
import { PortableText } from "@portabletext/react";
export const GiftCard: React.FC<{
  title: string;
  description: any[];
  image: SanityImageObject;
  links: (LinkType | NavLink)[];
}> = t0 => {
  const $ = _c(17);
  const {
    title,
    description,
    image,
    links
  } = t0;
  useRouter();
  let t1;
  if ($[0] !== image) {
    t1 = <div className={styles.giftcardimage}><ResponsiveImage image={image} layout="responsive" sizes="(min-width: 1920px) 857px, (min-width: 1181px) 45vw, 90vw" /></div>;
    $[0] = image;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <h3>{title}</h3>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== description) {
    t3 = <PortableText value={description} />;
    $[4] = description;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div>{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== links) {
    t5 = <Links links={links} />;
    $[9] = links;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className={styles.giftcardtext}>{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t1 || $[15] !== t6) {
    t7 = <div className={styles.giftcard}>{t1}{t6}</div>;
    $[14] = t1;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};